import { gettext } from '@eventbrite/i18n';
import { trackAnalyticsEvent } from '@eventbrite/site-analytics';
import React from 'react';
import { GACodes, Settings } from '../../types';

type Props = {
    eventId: string;
    settings: Settings;
};

export const CreatorBanner = ({ eventId, settings }: Props) => {
    return (
        <div
            className="eds-notification-bar eds-notification-bar eds-notification-bar--neutral"
            role="alert"
        >
            <div className="eds-notification-bar__content">
                <div className="eds-notification-bar__content-child eds-g-cell">
                    {gettext('Need to make some updates?')}{' '}
                    <a
                        href={`/myevent?eid=${eventId}`}
                        target="_blank"
                        id="edit-event"
                        rel="noopener noreferrer"
                        onClick={() =>
                            settings.featureFlags
                                ?.disable_require_base_config_js_on_listings
                                ? trackAnalyticsEvent({
                                      category: GACodes.GA_CATEGORY_LISTING,
                                      action: GACodes.GA_ACTION_EDIT_EVENT,
                                  })
                                : null
                        }
                    >
                        {gettext('Edit event')}
                    </a>
                </div>
            </div>
        </div>
    );
};
